import clsx from "clsx";
import React from "react";
import Markdown from "react-markdown";
import { bubble } from "./ChatMessage.css";

export interface ChatMessageProps extends React.HTMLAttributes<HTMLDivElement> {
  /**
   * Who sent the message — sets the bubble's alignment and colour.
   */
  role: "user" | "assistant";
  /**
   * The message text. Assistant messages render as Markdown; user messages
   * render as plain text.
   */
  content: string;
}

/**
 * A single chat message bubble. The `role` picks the bubble variant (user
 * bubbles sit on the right in the primary colour, assistant bubbles on the
 * left) and whether the content renders as Markdown.
 */
export function ChatMessage({
  role,
  content,
  className,
  ...props
}: ChatMessageProps) {
  return (
    <div
      className={clsx(bubble[role], className)}
      data-testid={`chat-message-${role}`}
      {...props}
    >
      {role === "assistant" ? <Markdown>{content}</Markdown> : content}
    </div>
  );
}
